/**
 * Concatène des classes CSS en ignorant les valeurs fausses.
 *
 * Isolé des composants : mélanger utilitaires et composants dans un même
 * fichier casse le rafraîchissement à chaud de Vite.
 */
export const cx = (...classes: (string | false | null | undefined)[]): string =>
  classes.filter(Boolean).join(' ');
